import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mantine/core';

// Shown after deleting an item from the dashboard
const UploadSuccess = () => {
    const navigate = useNavigate();

    return (
        <div className='flex flex-col px-8 pb-8 space-y-4 text-white'>
            <div className='text-lg'>Item deleted</div>
            <div className='text-zinc-400'>It no longer appears in the shop.</div>
            <Button onClick={() => navigate('/juli+dashboard/delete')}>Delete another item</Button>
        </div>
    )
}

export default UploadSuccess
